module.exports = __webpack_public_path__ + "img/Haru.e6750cf7.png";